import { AutogenModelEdiImagingConfig, AutogenRowEdiImagingConfig } from "./autogen/AutogenModelEdiImagingConfig";

export class ModelEdiImagingConfig extends AutogenModelEdiImagingConfig<RowEdiImagingConfig> {
	constructor() {
		super(RowEdiImagingConfig);
	}
}

export class RowEdiImagingConfig extends AutogenRowEdiImagingConfig {
}